import type React from 'react';
import { useEffect } from 'react';
import { AdMob, BannerAdPosition, BannerAdSize } from '@capacitor-community/admob';
import { Capacitor } from '@capacitor/core';
import { useLocation } from 'react-router-dom';
import { adAndroidBanner, adIosBanner, shouldDisplayAds } from 'helpers/InitAdmob';

const AdmobBanner: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const showAd = async () => {
      await AdMob.showBanner({
        adId: Capacitor.getPlatform() === 'ios' ? adIosBanner : adAndroidBanner,
        adSize: BannerAdSize.BANNER,
        position: BannerAdPosition.BOTTOM_CENTER,
        margin: Capacitor.getPlatform() === 'ios' ? 150 : 100,
        isTesting: false, // Set to false in production
      });
    };

    try {
      if (shouldDisplayAds(location.pathname)) {
        showAd();
      } else {
        AdMob.removeBanner();
      }
    } catch (e) {
      console.warn(e);
    }

    //eslint-disable-next-line
  }, []);

  return null; // No UI needed for banner ads
};

export default AdmobBanner;
